import { usePermissions } from './usePermissions'

/**
 * Purchase Order Permissions Composable
 * Provides permission checking functions for purchase order operations
 */
export function usePurchaseOrderPermissions() {
  const { hasAnyPermission } = usePermissions()

  /**
   * Check if user can view purchase order details
   */
  const canViewPurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.ViewDetails',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user can create purchase orders
   */
  const canCreatePurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.Create',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user can edit purchase orders
   */
  const canEditPurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.Edit',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user can approve/submit purchase orders
   */
  const canApprovePurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.Approve',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user can delete/decline purchase orders
   */
  const canDeletePurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.Delete',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user can export purchase orders
   */
  const canExportPurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.Export',
      'Supplier.PurchaseOrders'
    ])
  }

  /**
   * Check if user has any access to purchase order features
   * Used for menu visibility and route access
   */
  const canAccessPurchaseOrders = () => {
    return hasAnyPermission([
      'Supplier.PurchaseOrders.ViewDetails',
      'Supplier.PurchaseOrders.Create',
      'Supplier.PurchaseOrders.Edit',
      'Supplier.PurchaseOrders.Approve',
      'Supplier.PurchaseOrders.Export',
      'Supplier.PurchaseOrders.Delete',
      'Supplier.PurchaseOrders'
    ])
  }

  return {
    canViewPurchaseOrders,
    canCreatePurchaseOrders,
    canEditPurchaseOrders,
    canApprovePurchaseOrders,
    canDeletePurchaseOrders,
    canExportPurchaseOrders,
    canAccessPurchaseOrders
  }
}
